<script>
import moment from 'moment'
import ListView from '@/components/common/ListView'
import PersonalAccessTokenDetail from '@/components/personal-access-tokens/PersonalAccessTokenDetail'
import { mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      title: 'Personal Access Tokens',
      searchAttributes: ['hexId', 'name', 'description'],
      selectedPersonalAccessToken: null,
      initialFetchUpdating: false,
      refreshFetchUpdating: false,
      deleteUpdating: false
    }
  },

  computed: {
    ...mapState({
      personalAccessTokens: state =>
        state.personalAccessTokens.userPersonalAccessTokens
    }),
    ...mapGetters({
      can: 'can'
    }),
    updating() {
      return (
        this.initialFetchUpdating ||
        this.refreshFetchUpdating ||
        this.deleteUpdating
      )
    }
  },

  watch: {
    selectedPersonalAccessToken() {
      this.routeEdit()
    },
    personalAccessTokens() {
      this.getSelectedFromRoute()
    }
  },

  methods: {
    routeEdit() {
      if (this.selectedPersonalAccessToken) {
        this.$router.replace({
          name: 'personal-access-token-detail',
          params: { hexId: this.selectedPersonalAccessToken.hexId }
        })
      } else {
        this.$router.replace({ name: 'personal-access-token-list' })
      }
    },

    getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'personal-access-token-detail') {
        this.selectedPersonalAccessToken = this.personalAccessTokens.find(
          personalAccessToken => {
            return personalAccessToken.hexId === this.$route.params.hexId
          }
        )
      }
    },

    create() {
      this.$router.push({ name: 'personal-access-token-create' })
    },

    async refreshItem() {
      this.refreshFetchUpdating = true
      await this.$store.dispatch('fetchUserPersonalAccessTokens')
      this.refreshFetchUpdating = false
    },

    async deleteItem() {
      this.deleteUpdating = true
      try {
        await this.$store.dispatch(
          'deletePersonalAccessToken',
          this.selectedPersonalAccessToken
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Personal Access Token deleted Successfully',
          description: `${this.selectedPersonalAccessToken.hexId} has been deleted successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.selectedPersonalAccessToken = null
        this.routeEdit()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Personal Access Token deletion Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      try {
        await this.$store.dispatch('fetchUserPersonalAccessTokens')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Personal Access Token(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.deleteUpdating = false
    }
  },

  async created() {
    this.initialFetchUpdating = true
    await this.$store.dispatch('fetchUserPersonalAccessTokens')
    this.getSelectedFromRoute()
    this.initialFetchUpdating = false
  },

  components: {
    PersonalAccessTokenDetail,
    ListView
  }
}
</script>

<template>
  <list-view
    search
    :items="personalAccessTokens"
    :title="title"
    :search-attributes="searchAttributes"
    create-action
    item-key="hexId"
    @refresh="refreshItem"
    refresh-action
    delete-action
    @create="create"
    @delete="deleteItem"
    v-model="selectedPersonalAccessToken"
    :updating="updating"
  >
    <template slot="list-item" slot-scope="slotProps">
      <div
        style="margin-right: 20px; height: 90%; width: 5px;"
        :class="
          selectedPersonalAccessToken &&
          slotProps.item.hexId === selectedPersonalAccessToken.hexId
            ? 'secondary'
            : 'grey'
        "
      ></div>
      <v-list-tile-content>
        <v-list-tile-title v-text="slotProps.item.name"></v-list-tile-title>
        <v-list-tile-sub-title
          v-html="slotProps.item.description"
        ></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>

    <personal-access-token-detail
      slot="list-item-detail"
      slot-scope="slotProps"
      v-if="slotProps.item != null"
      :personal-access-token="slotProps.item"
    ></personal-access-token-detail>
  </list-view>
</template>
